import { Component, OnInit } from '@angular/core';

import { AuthService, ConfigService } from './core';
import { ToastService } from './domains/shared/components/toast/services/toast.service';
import './types';

@Component({
  selector: 'sgt-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.less'],
})
export class AppComponent implements OnInit {
  toasts$ = this.toastService.toasts$;
  constructor(
    private authService: AuthService,
    private configService: ConfigService,
    public toastService: ToastService
  ) {}

  ngOnInit() {
    this.loadConfig();
  }

  /** Carrega as configurações da aplicação com o usuário estiver autenticado */
  private loadConfig() {
    if (this.authService.isAuth) {
      this.configService.load().subscribe(
        () => {},
        () => {}
      );
    }
  }
}
